import BaseComponent from 'scripts/BaseComponent.js';

export default class FilterCategory extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      categoryToggle: '.js-categoryToggle',
      categoryContent: '.js-categoryContent',
    };

    this.dom = {
      $component: component,
      $categoryToggle: this.$get(this.refs.categoryToggle),
      $categoryContent: this.$get(this.refs.categoryContent),
    };

    this.state = {
      categoryOpen: false,
      categoryOpenClass: 'open-filter-category',
      allowScrollClass: 'allow-scroll',
      animationDuration: 500,
    };

    this.mount();
  }

  mount() {
    const { dom } = this;
    super.mount();

    this.setClick(dom.$categoryToggle, this.toggleCategory);
  }

  toggleCategory() {
    const { state } = this;

    if (state.categoryOpen) {
      this.closeCategory();
    } else {
      this.openCategory();
    }
  }

  openCategory() {
    const { dom, state } = this;

    dom.$component.classList.add(state.categoryOpenClass);
    setTimeout(() => dom.$component.classList.add(state.allowScrollClass), state.animationDuration);
    dom.$categoryContent.setAttribute('aria-hidden', 'false');
    dom.$categoryContent.setAttribute('aria-expanded', 'true');
    state.categoryOpen = true;
  }

  closeCategory() {
    const { dom, state } = this;

    dom.$component.classList.remove(state.categoryOpenClass, state.allowScrollClass);
    dom.$categoryContent.setAttribute('aria-hidden', 'true');
    dom.$categoryContent.setAttribute('aria-expanded', 'false');
    state.categoryOpen = false;
  }
}
